import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
@Component({
    selector: 'icon-adhesion',
    template: `
        <ng-template #template>
            <svg width="20" height="20" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg" [ngClass]="class">
                <path
                    d="M2.7 5.14286C3.69281 5.14286 4.5 4.37411 4.5 3.42857C4.5 2.48304 3.69281 1.71429 2.7 1.71429C1.70719 1.71429 0.9 2.48304 0.9 3.42857C0.9 4.37411 1.70719 5.14286 2.7 5.14286ZM15.3 5.14286C16.2928 5.14286 17.1 4.37411 17.1 3.42857C17.1 2.48304 16.2928 1.71429 15.3 1.71429C14.3072 1.71429 13.5 2.48304 13.5 3.42857C13.5 4.37411 14.3072 5.14286 15.3 5.14286ZM16.2 6H14.4C13.905 6 13.4578 6.19018 13.1316 6.49821C14.265 7.09018 15.0694 8.15893 15.2437 9.42857H17.1C17.5978 9.42857 18 9.04554 18 8.57143V7.71429C18 6.76875 17.1928 6 16.2 6ZM9 6C10.7409 6 12.15 4.65804 12.15 3C12.15 1.34196 10.7409 0 9 0C7.25906 0 5.85 1.34196 5.85 3C5.85 4.65804 7.25906 6 9 6ZM11.16 6.85714H10.9266C10.3416 7.125 9.69187 7.28571 9 7.28571C8.30812 7.28571 7.66125 7.125 7.07344 6.85714H6.84C5.05125 6.85714 3.6 8.23929 3.6 9.94286V10.7143C3.6 11.4241 4.20469 12 4.95 12H13.05C13.7953 12 14.4 11.4241 14.4 10.7143V9.94286C14.4 8.23929 12.9487 6.85714 11.16 6.85714ZM4.86844 6.49821C4.54219 6.19018 4.095 6 3.6 6H1.8C0.807187 6 0 6.76875 0 7.71429V8.57143C0 9.04554 0.402187 9.42857 0.9 9.42857H2.75344C2.93062 8.15893 3.735 7.09018 4.86844 6.49821Z"
                    fill="currentColor"
                />
            </svg>
        </ng-template>
    `,
})
export class IconAdhesionComponent {
    @Input() class: any = '';
    @ViewChild('template', { static: true }) template: any;
    constructor(private viewContainerRef: ViewContainerRef) {}
    ngOnInit() {
        this.viewContainerRef.createEmbeddedView(this.template);
        this.viewContainerRef.element.nativeElement.remove();
    }
}
